module.exports = __webpack_public_path__ + "static/media/Poppins-BoldItalic-latin.858549c2.woff2";